module.exports = __webpack_public_path__ + "media/images/gallery/constellations/vulpecula/vul_vis-f27ad4fad55ef2f033e00a8710da8af4.jpg";